import angular from 'angular';
import StateStoreService from './stateStore.service.js';

let stateStoreModule = angular.module('stateStore', [])

    .service('StateStoreService', StateStoreService)
    .name;

export default stateStoreModule;